import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import HistoryIcon from '@mui/icons-material/History';
import SearchIcon from '@mui/icons-material/Search';
import TuneIcon from '@mui/icons-material/Tune';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import AdapterDateFns from '@date-io/date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import {
  Autocomplete,
  Backdrop,
  Badge,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  ClickAwayListener,
  createTheme,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import {
  DataGridPro,
  GridColDef,
  GridFooter,
  GridFooterContainer,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport
} from '@mui/x-data-grid-pro';
import axios from 'axios';
import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from 'src/appConfig';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { getPoratlHost } from 'src/components/common/hooks/useUtil';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useGetCountriesQuery, useGetSitesQuery, useGetStudiesQuery } from 'src/components/Services/Utils';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSearchHistory } from 'src/store/searchReducer';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { setUserDocPermissions } from 'src/store/User';
import StyledMenu from 'src/theme/StyledTheme';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import CustomNoRowsOverlay from './CustomNoRowsOverlay';
import './searchComponentStyles.scss';
import SearchPreset from './SearchPreset';
import { CustomPagination } from 'src/util/DataTableFooter';
import newconfig from '../../../appConfig';
import { hideLoader, showLoader } from 'src/store/Loader';
import { Loader } from 'src/components/common/Loader';
const SearchComponent = (props: any) => {
  const isLoaderLoading: any = useSelector((state: AppState) => state.loader.isLoading);
  const [loaderStatus, setLoaderStatus] = useState(isLoaderLoading);
  const [showResult, setShowResult] = useState<boolean>(false);
  const [showSuggestion, setShowSuggestion] = useState<boolean>(false);
  const [showHistory, setShowHistory] = useState<boolean>(false);
  const [searchResultRows, setSearchResultRows] = useState([]);
  const [suggestionResult, setSuggesstionResult] = useState([]);
  const [inputValue, setInputValue] = useState<string>('');
  const searchHistoryStore: any = useSelector((state: AppState) => state.searchDetails.history);
  const [recentHistoryResult, setRecentHistoryResult] = useState<any>(searchHistoryStore ? searchHistoryStore : []);
  const [treeData, setTreeData] = useState<any>([]);
  const [disablePresetSave, setDisablePresetSave] = useState<boolean>(true);
  const [type, setType] = useState<any>([]);
  const [subType, setSubType] = useState<any>([]);
  const [artifactName, setArtifactName] = useState<any>([]);
  const [enable, setEnable] = useState<boolean>(false);
  const [isSave, setSave] = useState<boolean>();
  const [presetName, setPresetName] = useState<string>('');
  const [badgeCount, setBadgeCount] = useState<number>(0);
  const [fromHistory, setFromHistory] = useState<boolean>(false);
  const [rowCount, setRowCount] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [studyList, setStudyList] = useState<any>([]);
  const [siteList, setSiteList] = useState<any>([]);
  const [docStatuses, setDocStatuses] = useState<any>([]);
  const [milestones, setMilestones] = useState<any>([]);
  const [includePhi, setIncludePhi] = useState<boolean>(false);
  const [docReducted, setDocReducted] = useState<boolean>(false);
  const isfInstance = axios.create({ baseURL: `${newconfig.appConfig.apiisf}` });
  const [presetSearchData, setPresetSearchData] = useState<any>({});
  const [metaData, setMetaData] = useState<any>({});
  const [operator, setOperator] = useState<string>('equals');
  const [objData, setObjData] = useState<any>('');
  const [presetId, setPresetId] = useState<string>('');
  const { presetFilter, isPreset, isEdit, presetObject, isDeletePreset } = presetSearchData;
  const [isAction, setIsAction] = useState<any>('');
  const [typeVal, setTypeVal] = useState<string | null>('');
  const [inputTypeVal, setInputTypeVal] = useState('');
  const [subTypeVal, setSubTypeVal] = useState<string | null>('');
  const [inputSubTypeVal, setInputSubTypeVal] = useState<string>('');
  const [artifactNameVal, setArtifactNameVal] = useState<string | null>('');
  const [inputArtifactNameVal, setInputArtifactNameVal] = useState<string>('');
  const [docStatusVal, setDocStatusVal] = useState<string>('');
  const docNameInput = useRef<HTMLInputElement>(null);
  const docNoInput = useRef<HTMLInputElement>(null);
  const [docNameVal, setDocNameVal] = useState<string>('');
  const [docIdVal, setDocIdVal] = useState<string>('');
  const [docLevelVal, setDocLevelVal] = useState<string>('');
  const [docStudyVal, setDocStudyVal] = useState<string>('');
  const [countryVal, setCountryVal] = useState<string>('');
  const [siteVal, setSiteVal] = useState<string>('');
  const [milestoneVal, setMilestoneVal] = useState<string>('');
  const [mileStatusVal, setMileStatusVal] = useState<string>('');
  const [productVal, setProductVal] = useState<string>('');
  const [createdbyVal, setCreatedbyVal] = useState<string>('');
  const [modifiedbyVal, setModifiedbyVal] = useState<string>('');
  const [error, setError] = useState('');
  const [isClear, setClear] = useState<boolean>(false);
  const [p1Expand, setP1Expand] = useState<boolean>(false);
  const [p2Expand, setP2Expand] = useState<boolean>(false);
  const [p3Expand, setP3Expand] = useState<boolean>(false);
  const [isEditStarted, setIsEditStarted] = useState<boolean>(false);
  const [dataResult, setDataResult] = React.useState<any>([]);
  const [usersList, setUsersList] = useState([]);
  const [userError, setUsersError] = useState(null);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [clickListner, setClickListner] = useState(true);
  const [isPresetName, setIsPresetName] = useState<boolean>(false);
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + '' + user.lastName}`;
  const dispatch = useDispatch();
  const docService = new DocManagementService();
  const { preferedFormatForDatePicker, preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const isfLevel = 'Site';
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);

  const searchSuggestion = async (searchText: string) => {
    const response: any = await docService.getSearchSuggestions(
      searchText,
      findScope(),
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    setSuggesstionResult(response.data);
    if (response.data === null || response.data.length === 0) {
      setShowSuggestion(false);
    } else {
      setShowSuggestion(true);
    }
  };

  const getAllUsers = async () => {
    const response: any = await docService.getAllUsers(selectedStudy, isfLevel, '--', selectedCountry, selectedSite);
    if (response?.data) {
      const userData = response?.data.filter((u: any) => u.email !== null);
      setUsersList(userData);
      setUsersError(null);
    } else {
      setUsersError(response?.error);
    }
  };

  const getMasterCodeList = async () => {
    const response2: any = await docService.getCodeList(
      'ISFSTAT',
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    const filterStatus = response2.data.filter((item: any) => item !== 'Excepted');
    setDocStatuses(filterStatus);
    // const response3: any = await docService.getCodeList('isfDEPT');
    // setDepartments(response3.data);
    const response4: any = await docService.getCodeList(
      'ISFMILS',
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    setMilestones(response4.data);
  };

  const handleSearchInputChange = (e: any) => {
    setShowResult(false);
    setInputValue(e.target.value);
    if (e.target.value.length >= 3) {
      setShowHistory(false);
      searchSuggestion(e.target.value);
      setAnchorElSearch(e.currentTarget);
    } else {
      setShowSuggestion(false);
      setAnchorElSearch(null);
    }
  };

  const globalSearch = async (i: any, action = 'click', from: number, size: number) => {
    setAnchorElSearch(null);
    setIsAdvanceSearch(false);
    setIsPresetSearch(false);
    const selectedResult = {
      filter_column: action === 'click' ? suggestionResult[i]['filter_column'] : '*',
      filter_model: action === 'click' ? suggestionResult[i]['filter_model'] : '',
      actual_value: action === 'click' ? suggestionResult[i]['actual_value'] : inputValue,
      occurrences: action === 'click' ? suggestionResult[i]['occurrences'] : 0
    };
    let updatedRecentHistoryResults: any = [];
    if (recentHistoryResult.length > 0) {
      const obj = recentHistoryResult.find((o: any, i: number) => {
        if (o.actual_value === selectedResult.actual_value && o.filter_column === selectedResult.filter_column) {
          updatedRecentHistoryResults = [...recentHistoryResult];
          updatedRecentHistoryResults.splice(i, 1);
          updatedRecentHistoryResults.unshift(selectedResult);
          setRecentHistoryResult(updatedRecentHistoryResults);
          return true;
        } else {
          updatedRecentHistoryResults = [selectedResult, ...recentHistoryResult];
          setRecentHistoryResult(updatedRecentHistoryResults);
        }
      });
    } else {
      updatedRecentHistoryResults = [selectedResult, ...recentHistoryResult];
      setRecentHistoryResult(updatedRecentHistoryResults);
    }

    action === 'click' ? setInputValue(selectedResult['actual_value']) : setInputValue(inputValue);
    const dataObj = {
      query_filters: [
        {
          name: action === 'click' ? selectedResult['filter_column'] : inputValue !== '' ? '*' : '',
          value: action === 'click' ? selectedResult['actual_value'] : inputValue,
          operation: action === 'click' ? operator : 'contains'
        }
      ],
      filter_types: findScope()
    };
    setSearchHistory(dispatch, {
      history: updatedRecentHistoryResults
    });
    setObjData(i);
    setIsAction(action);
    const response: any = await docService.getGlobalSearch(
      dataObj,
      null,
      null,
      null,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search',
      from,
      size
    );

    if (response.data) {
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } else {
      setSearchResultRows([]);
      setRowCount(0);
    }
  };
  const handleAdvFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsEditStarted(true);
    if (e.target.name === 'isf_doc_status') setDocStatusVal(e.target.value);
    if (e.target.name === 'isf_document_name') setDocNameVal(e.target.value);
    if (e.target.name === 'isf_document_id') setDocIdVal(e.target.value);
    if (e.target.name === 'isf_doc_level') setDocLevelVal(e.target.value);
    if (e.target.name === 'isf_doc_study') setDocStudyVal(e.target.value);
    if (e.target.name === 'isf_doc_country') setCountryVal(e.target.value);
    if (e.target.name === 'isf_doc_site') setSiteVal(e.target.value);
    if (e.target.name === 'isf_doc_milestone') setMilestoneVal(e.target.value);
    if (e.target.name === 'isf_doc_milestone_status') setMileStatusVal(e.target.value);
    if (e.target.name === 'isf_doc_viewer_product_detail') setProductVal(e.target.value);
    if (e.target.name === 'isf_doc_viewer_created_by') setCreatedbyVal(e.target.value);
    if (e.target.name === 'isf_doc_viewer_last_modified_by') setModifiedbyVal(e.target.value);
  };

  const cbxPHIClick = async (e: any) => {
    setIsEditStarted(true);
    if (!e.target.checked) {
      setIncludePhi(false);
    } else {
      setIncludePhi(true);
    }
  };
  const cbxReductedClick = async (e: any) => {
    setIsEditStarted(true);
    if (!e.target.checked) {
      setDocReducted(false);
    } else {
      setDocReducted(true);
    }
  };

  const qf: any = [];
  const buildPayload = () => {
    if (typeVal !== '' && typeVal !== null) qf.push({ name: 'isf_doc_type', value: typeVal, operation: 'equals' });
    if (subTypeVal !== '' && subTypeVal !== null)
      qf.push({ name: 'isf_doc_subtype', value: subTypeVal, operation: 'equals' });
    if (artifactNameVal !== '' && artifactNameVal !== null)
      qf.push({ name: 'isf_artifact_name', value: artifactNameVal, operation: 'equals' });
    if (docStatusVal !== '') qf.push({ name: 'isf_doc_status', value: docStatusVal, operation: 'equals' });
    if (docNameVal !== '')
      qf.push({ name: 'isf_document_name', value: docNameVal, operation: 'case_insensitive_like' });
    if (docIdVal !== '') qf.push({ name: 'isf_document_id', value: docIdVal, operation: 'case_insensitive_like' });
    if (docLevelVal !== '') qf.push({ name: 'isf_doc_level', value: docLevelVal, operation: 'equals' });
    if (docStudyVal !== '' && docStudyVal !== null && countryVal !== undefined)
      qf.push({ name: 'isf_doc_study', value: docStudyVal, operation: 'equals' });
    if (countryVal !== '' && countryVal !== null && countryVal !== undefined)
      qf.push({ name: 'isf_doc_country', value: countryVal, operation: 'equals' });
    if (siteVal !== '' && siteVal !== null && countryVal !== undefined)
      qf.push({ name: 'isf_doc_site', value: siteVal, operation: 'equals' });
    if (milestoneVal !== '') qf.push({ name: 'isf_doc_milestone', value: milestoneVal, operation: 'equals' });
    if (mileStatusVal !== '') qf.push({ name: 'isf_doc_milestone_status', value: mileStatusVal, operation: 'equals' });
    if (productVal !== '') qf.push({ name: 'isf_doc_viewer_product_detail', value: productVal, operation: 'equals' });
    if (createdbyVal !== '') qf.push({ name: 'isf_doc_viewer_created_by', value: createdbyVal, operation: 'equals' });
    if (modifiedbyVal !== '')
      qf.push({ name: 'isf_doc_viewer_last_modified_by', value: modifiedbyVal, operation: 'equals' });
    if (includePhi) {
      qf.push({ name: 'isf_doc_viewer_includes_phi', value: true, operation: operator });
    }
    if (docReducted) {
      qf.push({ name: 'isf_doc_viewer_red_certified_copy', value: 'Y', operation: operator });
    }
    if (uploadedFromDate !== null) {
      qf.push({
        name: 'created_on',
        value: moment(new Date(uploadedFromDate)).format(userPreferedDateFormat.toUpperCase()) + ' 00:00:00',
        operation: 'greater_than_or_equal'
      });
    }
    if (uploadedToDate !== null) {
      qf.push({
        name: 'created_on',
        value: moment(new Date(uploadedToDate)).format(userPreferedDateFormat.toUpperCase()) + ' 23:59:59',
        operation: 'less_than_or_equal'
      });
    }
    if (modifiedFromDate !== null) {
      qf.push({
        name: 'updated_on',
        value: moment(new Date(modifiedFromDate)).format(userPreferedDateFormat.toUpperCase()) + ' 00:00:00',
        operation: 'greater_than_or_equal'
      });
    }
    if (modifiedToDate !== null) {
      qf.push({
        name: 'updated_on',
        value: moment(new Date(modifiedToDate)).format(userPreferedDateFormat.toUpperCase()) + ' 23:59:59',
        operation: 'less_than_or_equal'
      });
    }
    return qf;
  };

  const advancedFilterSearch = async (from: number, size: number) => {
    if (handleInvalidDate()) return;
    setSearchResultRows([]);
    setIsAdvanceSearch(true);
    setIsPresetSearch(false);
    setShowResult(false);
    setInputValue('');
    handleCloseFilter();
    const res = buildPayload();
    setBadgeCount(qf.length);
    const dataObj = {
      query_filters: qf,
      filter_types: findScope()
    };
    try {
      const response: any = await docService.getGlobalSearch(
        dataObj,
        null,
        null,
        null,
        isfLevel,
        process.env.REACT_APP_NAME,
        'Search',
        from,
        size
      );
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } catch (error) {
      setShowResult(true);
    }
  };

  const presetFilterSearch = async (from: number, size: number) => {
    setIsEditStarted(false);
    setIsPresetSearch(true);
    setIncludePhi(presetObject && presetObject.isf_doc_viewer_includes_phi);
    setDocReducted(presetObject && presetObject.isf_doc_viewer_red_certified_copy === 'Y' ? true : false);
    for (const prop in presetFilter) {
      if (presetFilter[prop].operation === 'greater_than_or_equal' && presetFilter[prop].name === 'created_on') {
        setuploadedFromDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'less_than_or_equal' && presetFilter[prop].name === 'created_on') {
        setuploadedToDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'greater_than_or_equal' && presetFilter[prop].name === 'updated_on') {
        setmodifiedFromDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].operation === 'less_than_or_equal' && presetFilter[prop].name === 'updated_on') {
        setmodifiedToDate(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_type') {
        setTypeVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_subtype') {
        setSubTypeVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_artifact_name') {
        setArtifactNameVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_status') {
        setDocStatusVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_document_name') {
        setDocNameVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_document_id') {
        setDocIdVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_level') {
        setDocLevelVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_study') {
        setDocStudyVal(presetFilter[prop].value);
        setCurrentStudy(presetObject.isf_doc_study);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_country') {
        setCountryVal(presetFilter[prop].value);
        setCurrentCountry(presetObject.isf_doc_country);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_site') {
        setSiteVal(presetFilter[prop].value);
        setP1Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_milestone') {
        setMilestoneVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_milestone_status') {
        setMileStatusVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_viewer_product_detail') {
        setProductVal(presetFilter[prop].value);
        setP2Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_viewer_created_by') {
        setCreatedbyVal(presetFilter[prop].value);
        setP3Expand(true);
      }
      if (presetFilter[prop].name === 'isf_doc_viewer_last_modified_by') {
        setModifiedbyVal(presetFilter[prop].value);
        setP3Expand(true);
      }
    }
    if (presetObject) {
      setDocStudyVal(presetObject.isf_doc_study);
      setCurrentStudy(presetObject.isf_doc_study);
      setCountryVal(presetObject.isf_doc_country);
      setCurrentCountry(presetObject.isf_doc_country);
      setSiteVal(presetObject.isf_doc_site);
      setP1Expand(true);
    }
    setPresetSearchData({ ...presetSearchData });
    setOpen(false);
    const count = presetFilter.filter((item: any) => item.value !== null && item.value !== '');
    setBadgeCount(count.length);
    setSearchResultRows([]);
    setShowResult(false);
    setInputValue('');
    const dataObj = {
      query_filters: presetFilter,
      filter_types: findScope()
    };
    setObjData(dataObj);
    const response: any = await docService.getGlobalSearch(
      dataObj,
      null,
      null,
      null,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search',
      from,
      size
    );
    if (response.data) {
      const modRows: any = getMapFields(response?.data?.selected_data);
      setShowResult(true);
      setSearchResultRows(modRows);
      setRowCount(response.data.record_count);
    } else {
      if (presetFilter) {
        setShowResult(true);
      }
    }
  };

  const findScope = () => {
    let arr: string[] = [];
    if (NameCbx) arr.push('Name');
    if (DetailCbx) arr.push('Detail');
    if (PropertiesCbx) arr.push('Properties');
    if (ContentCbx) arr.push('Content');
    if (NameCbx && DetailCbx && PropertiesCbx && ContentCbx) arr = ['All'];
    return arr;
  };

  const globalSearchFromHistory = async (i: any, from: number, size: number) => {
    setAnchorElSearch(null);
    setInputValue(recentHistoryResult[i]['actual_value']);
    const dataObj = {
      query_filters: [
        {
          name: recentHistoryResult[i]['filter_column'],
          value: recentHistoryResult[i]['actual_value'],
          operation: operator
        }
      ],
      filter_types: findScope()
    };
    setObjData(i);
    const response: any = await docService.getGlobalSearch(
      dataObj,
      null,
      null,
      null,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search',
      from,
      size
    );
    const modRows: any = getMapFields(response?.data?.selected_data);
    setShowResult(true);
    setSearchResultRows(modRows);
    setRowCount(response.data.record_count);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
      setSearchResultRows([]);
      globalSearch(0, 'enter', 0, pageSize);
      setShowResult(true);
    }
  };

  const handleClickInsideInput = (e: any) => {
    setAnchorElSearch(null);
    if (inputValue === '' && recentHistoryResult.length !== 0) {
      setAnchorElSearch(e.currentTarget);
      setShowHistory(!showHistory);
    }
  };

  const getAdvSearchData = async () => {
    const res: any = await docService.getBinderViewerTree(
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    const treeList = [];
    const type = [];
    const subType = [];
    const artifactName = [];
    if (res.data) {
      for (const x of res.data) {
        type.push(x.isf_document_type);
        for (const y of x.isf_document_subtype) {
          subType.push(y.isf_document_subtype);
          for (const z of y.isf_artifact) {
            artifactName.push(z.isf_artifact_name);
          }
        }
      }
      treeList.push(res.data);
      setType(type);
      setSubType([...new Set(subType)]);
      setArtifactName([...new Set(artifactName)]);
    } else {
      store.dispatch(setSnackbarMessage('Error in Getting advanced filter details', 'error'));
    }
    setTreeData(treeList[0]);
  };

  const formatToDate = (params: any) => {
    const valueFormatted = String(params).split('T')[0].split('-');
    return `${valueFormatted[1]}/${valueFormatted[2]}/${valueFormatted[0]}`;
  };

  const handleClear = () => {
    // setClear(true);
    setMetaData({});
    setBadgeCount(0);
    setTypeVal('');
    setInputTypeVal('');
    setSubTypeVal('');
    setInputSubTypeVal('');
    setArtifactNameVal('');
    setInputArtifactNameVal('');
    setDocStatusVal('');
    setDocNameVal('');
    if (docNameInput && docNameInput.current) docNameInput.current.value = '';
    if (docNoInput && docNoInput.current) docNoInput.current.value = '';
    // if (qcCommentsInput && qcCommentsInput.current) qcCommentsInput.current.value = '';
    setDocIdVal('');
    setDocLevelVal('');
    setDocStudyVal('');
    setCountryVal('');
    setSiteVal('');
    setMilestoneVal('');
    setMileStatusVal('');
    setProductVal('');
    setCreatedbyVal('');
    setModifiedbyVal('');
    // setQcissueVal('');
    // setQccommentVal('');
    setuploadedFromDate(null);
    setuploadedToDate(null);
    setmodifiedFromDate(null);
    setmodifiedToDate(null);
    setIncludePhi(false);
    setDocReducted(false);
    // setShowResult(false);
  };

  useEffect(() => {
    getAdvSearchData();
    getMasterCodeList();
    getAllUsers();
    window.scrollTo(0, 0);
    setDataGridComponent(true);
    return () => {
      props.routeInfo(null);
    };
  }, []);

  useEffect(() => {
    if (isPreset) {
      presetFilterSearch(0, pageSize);
    }
    setMetaData({ ...presetObject });
    setPresetId(presetSearchData.id);
  }, [presetFilter]);
  useEffect(() => {
    setMetaData({ ...presetObject });
    setPresetId(presetSearchData.id);
    setOpenDeletePreset(false);
    presetFilterSearch(0, pageSize);
  }, [isEdit]);

  useEffect(() => {
    if (isDeletePreset) {
      setOpenDeletePreset(true);
      setPresetId(presetSearchData.id);
    }
  }, [isDeletePreset]);

  const [currentStudy, setCurrentStudy] = useState('');
  const [currentCountry, setCurrentCountry] = useState('');
  const [countryList, setCountryList] = useState<any>([]);

  const {
    isLoading: getStudyLoad,
    data: studyData,
    isError: getStudyError,
    isSuccess: getStudySuccess,
    refetch: getStudyList
  } = useGetStudiesQuery();

  useEffect(() => {
    const temp: string[] = [];
    if (studyData && studyData.length != 0) {
      studyData.map((study: any) => {
        temp.push(study.name);
      });
    }
    setStudyList(temp);
  }, [studyData]);

  const {
    isLoading,
    data: countryData,
    isError,
    isSuccess,
    refetch: getCountries
  } = useGetCountriesQuery(currentStudy);

  useEffect(() => {
    getCountries();
  }, [currentStudy]);

  useEffect(() => {
    const tempC: any = [];
    if (countryData && countryData.length != 0) {
      countryData.map((country: any) => {
        tempC.push(country.name);
      });
    }
    setCountryList(tempC);
  }, [countryData]);

  const {
    isLoading: getSiteLoading,
    data: sitesData,
    isError: getSiteError,
    isSuccess: getSiteSuccess,
    refetch: getSites
  } = useGetSitesQuery({ currentStudy, currentCountry });
  useEffect(() => {
    getSites();
  }, [currentCountry]);

  useEffect(() => {
    const tempS: string[] = [];
    if (sitesData && sitesData.length != 0) {
      sitesData.map((site: any) => {
        tempS.push(site.name);
      });
    }
    setSiteList(tempS);
  }, [sitesData]);

  const handleChangeFilter = (e: any) => {
    setFilter(e.target.value);
    const temp = e.target.value == 'Newest' ? 'desc' : 'asc';
  };

  const [value, setValue] = React.useState(0);
  const [filter, setFilter] = React.useState('Newest');

  const handleChangeTab = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

  // All button dropdown with checkbox
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handlePresetName = (e: any) => {
    if (e.target.value.trim()) {
      setDisablePresetSave(false);
      setPresetName(e.target.value);
    } else {
      setDisablePresetSave(true);
    }
  };
  const handleSaveDialogBox = () => {
    setEnable(true);

    setAnchorElSearch(null);

    setDisablePresetSave(true);
  };
  const handleSaveClose = () => {
    if (presetName) {
      setOpenConfirmExit(true);
    } else {
      setPresetName('');
      setEnable(false);
      setOpenConfirmExit(false);
    }
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };
  const formatDate = (params: any) => {
    return preferedDateFormat(params.value);
  };
  const [AllCbx, setAllCbx] = useState<boolean>(true);
  const [NameCbx, setNameCbx] = useState<boolean>(true);
  const [DetailCbx, setDetailCbx] = useState<boolean>(true);
  const [PropertiesCbx, setPropertiesCbx] = useState<boolean>(true);
  const [ContentCbx, setContentCbx] = useState<boolean>(true);
  const [scopeText, setScopeText] = useState<string>('All');

  const handleChangeAllCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAllCbx(!AllCbx);
    if (event.target.checked) {
      setNameCbx(true);
      setDetailCbx(true);
      setPropertiesCbx(true);
      setContentCbx(true);
    } else {
      setNameCbx(false);
      setDetailCbx(false);
      setPropertiesCbx(false);
      setContentCbx(false);
    }
  };
  const handleChangeNameCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameCbx(!NameCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (DetailCbx && PropertiesCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangeDetailCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetailCbx(!DetailCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && PropertiesCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangePropertiesCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPropertiesCbx(!PropertiesCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && DetailCbx && ContentCbx) {
        setAllCbx(true);
      }
    }
  };
  const handleChangeContentCbx = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContentCbx(!ContentCbx);
    if (!event.target.checked) {
      setAllCbx(false);
    } else {
      if (NameCbx && PropertiesCbx && DetailCbx) {
        setAllCbx(true);
      }
    }
  };

  useEffect(() => {
    let sCount = 0;
    if (NameCbx) sCount++;
    if (DetailCbx) sCount++;
    if (PropertiesCbx) sCount++;
    if (ContentCbx) sCount++;
    if (NameCbx && DetailCbx && PropertiesCbx && ContentCbx) sCount = 5;
    if (sCount === 5) setScopeText(`All`);
    else if (sCount === 0) setScopeText(`Select`);
    else setScopeText(`${sCount} Selected`);
  }, [AllCbx, NameCbx, DetailCbx, PropertiesCbx, ContentCbx]);

  const [anchorElSearch, setAnchorElSearch] = React.useState<HTMLButtonElement | null>(null);

  const handleClickSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElSearch(event.currentTarget);
  };

  const handleCloseSearch = () => {
    setAnchorElSearch(null);
  };

  const handleClickSearchInput = React.useState<null | HTMLElement>(null);

  const open2 = Boolean(anchorElSearch);
  const id = open2 ? 'simple-popover' : undefined;

  const [anchorElFilter, setAnchorElFilter] = React.useState<HTMLButtonElement | null>(null);
  const [open3, setOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState<PopperPlacementType>();
  const { checkPermission } = usePermissionWrapper();
  const handleClickFilter = (newPlacement: PopperPlacementType) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setClear(false);
    setAnchorElFilter(event.currentTarget);
    if (isEdit) {
      setPresetSearchData({ ...presetSearchData, isEdit: false });
      setOpen(false);
    } else {
      setOpen(prev => placement !== newPlacement || !prev);
    }
    setPlacement(newPlacement);
  };

  const handleClickAway = (event: any) => {
    if (clickListner) {
      if (event.target.localName === 'body') {
        return;
      }
      if (isEdit) setPresetSearchData({ isPreset: true, isEdit: false });
      setOpen(false);
    }
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpen(false);
  };

  const [filtervalue, setFilterValue] = React.useState('');

  const [openDeletePreset, setOpenDeletePreset] = React.useState(false);
  const handleCloseDeletePreset = () => {
    setOpenDeletePreset(false);
    setPresetSearchData({ ...presetSearchData, isDeletePreset: false });
  };
  const handleDeletePreset = async (isDelete: boolean) => {
    setSave(false);
    const presetData: any = {
      deleted_by: userName
    };

    const response: any = await docService.deletePresetFilter(
      presetId,
      presetData,
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'Search'
    );
    if (response.data) {
      setSave(isDelete);
      store.dispatch(setSnackbarMessage('Filter preset is deleted successfully.', 'success'));
      handleClear();
      setShowResult(false);
      setPresetSearchData({ ...presetSearchData, isDeletePreset: false });
    } else {
      store.dispatch(setSnackbarMessage('Error in deleteing Preset.', 'error'));
    }
    setOpenDeletePreset(false);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    isf_artifact_name: false,
    isf_doc_type: false,
    isf_doc_subtype: false
  });

  const gethashedurikey = (params: any) => {
    const data: any = searchResultRows.find((item: any) => item.id === params.id);
    setDataResult(data);
    return data.hashed_uri_key;
  };

  const [pageSize, setPageSize] = React.useState<number>(10);
  const appName = 'ISF';
  const columns: GridColDef[] = [
    {
      field: 'documentName',
      headerName: 'Document Name',
      flex: 1,
      minWidth: 200,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) =>
        checkPermission('view_document_details') ? (
          <Tooltip title={params.value!.toString()} placement="top">
            <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
          </Tooltip>
        ) : (
          params.value!.toString()
        )
    },
    {
      field: 'lastModified',
      headerName: 'Last Modified',
      flex: 1,
      minWidth: 130,
      valueGetter: formatDate
    },
    {
      field: 'uploadedBy',
      headerName: 'Uploaded By',
      flex: 1,
      minWidth: 150
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 110
    },
    {
      field: 'isf_artifact_name',
      headerName: 'Artifact Name',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'isf_doc_type',
      headerName: 'Document Type',
      flex: 1,
      minWidth: 180
    },
    {
      field: 'isf_doc_subtype',
      headerName: 'Document Subtype',
      flex: 1,
      minWidth: 180
    }
  ];

  const rows = [];

  function CustomToolbar() {
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName = 'Search Results ' + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    // const documentName = 'Search Results ' + exportDate;
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        {checkPermission('export_search_results') && (
          <GridToolbarExport
            csvOptions={{
              fileName: documentName
            }}
          />
        )}
      </GridToolbarContainer>
    );
  }

  const [uploadedFromDate, setuploadedFromDate] = React.useState<Date | null>(null);
  const [uploadedToDate, setuploadedToDate] = React.useState<Date | null>(null);
  const [modifiedFromDate, setmodifiedFromDate] = React.useState<Date | null>(null);
  const [modifiedToDate, setmodifiedToDate] = React.useState<Date | null>(null);
  const [errorUploadedFromDate, setErrorUploadedFromDate] = useState<string>('');
  const [errorUploadedToDate, setErrorUploadedToDate] = useState<string>('');
  const [errorModifiedFromDate, setErrorModifiedFromDate] = useState<string>('');
  const [errorModifiedToDate, setErrorModifiedToDate] = useState<string>('');
  const handleInvalidUploadedFromDate = (err: any, value: any) => {
    if (err === null) setErrorUploadedFromDate('');
    if (err === 'minDate') {
      setErrorUploadedFromDate('From date cannot be more then From To');
    } else if (err === 'disableFuture') {
      setErrorUploadedFromDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorUploadedFromDate('Invalid date(s)');
    }
  };
  const handleInvalidUploadedToDate = (err: any, value: any) => {
    if (err === null) setErrorUploadedToDate('');
    if (err === 'minDate') {
      setErrorUploadedToDate('To date cannot be less then From date');
    } else if (err === 'disableFuture') {
      setErrorUploadedToDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorUploadedToDate('Invalid date(s)');
    }
  };
  const handleInvalidModifiedFromDate = (err: any, value: any) => {
    if (err === null) setErrorModifiedFromDate('');
    if (err === 'minDate') {
      setErrorModifiedFromDate('From date cannot be more then From To');
    } else if (err === 'disableFuture') {
      setErrorModifiedFromDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorModifiedFromDate('Invalid date(s)');
    }
  };
  const handleInvalidModifiedToDate = (err: any, value: any) => {
    if (err === null) setErrorModifiedToDate('');
    if (err === 'minDate') {
      setErrorModifiedToDate('To date cannot be less then From date');
    } else if (err === 'disableFuture') {
      setErrorModifiedToDate('Dates cannot be a future dates');
    } else if (err === 'invalidDate') {
      setErrorModifiedToDate('Invalid date(s)');
    }
  };
  const handleInvalidDate = () => {
    if (errorUploadedFromDate !== '') {
      store.dispatch(setSnackbarMessage(errorUploadedFromDate, 'error'));
      return true;
    } else if (errorUploadedToDate !== '') {
      store.dispatch(setSnackbarMessage(errorUploadedToDate, 'error'));
      return true;
    } else if (errorModifiedFromDate !== '') {
      store.dispatch(setSnackbarMessage(errorModifiedFromDate, 'error'));
      return true;
    } else if (errorModifiedToDate !== '') {
      store.dispatch(setSnackbarMessage(errorModifiedToDate, 'error'));
      return true;
    } else {
      return false;
    }
  };
  const [anchorElPresetFilterBtn, setAnchorElPresetFilterBtn] = React.useState<null | HTMLElement>(null);
  const openPresetFilterBtn = Boolean(anchorElPresetFilterBtn);
  const handleClickPresetFilterBtn = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElPresetFilterBtn(event.currentTarget);
  };
  const handleClosePresetFilterBtn = () => {
    setAnchorElPresetFilterBtn(null);
  };
  function containsSpecialChars(str: string) {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/; // eslint-disable-line
    return specialChars.test(str);
  }
  const handleSavePresetFilter = async (isSave: boolean) => {
    if (containsSpecialChars(presetName)) {
      store.dispatch(setSnackbarMessage('Special Characters not allowed in preset name', 'error'));
    } else {
      setSave(false);
      const res_qf = buildPayload();
      const filterObj = {
        preset_name: presetName,
        preset_conditions: {
          filter: res_qf,
          sort: [
            {
              sort_by: 'string',
              sort_order: 'desc'
            }
          ],
          page: {
            start_from: 0,
            size: 10
          }
        },
        created_by: userName
      };

      const res: any = await docService.createFilterPreset(
        filterObj,
        selectedStudy,
        selectedCountry,
        selectedSite,
        isfLevel,
        process.env.REACT_APP_NAME,
        'Search'
      );

      if (res.error) {
        store.dispatch(setSnackbarMessage('Name already exist.', 'error'));
      } else {
        handleClear();
        handleSaveClose();
        setAnchorElFilter(null);
        setOpen(false);
        setSave(isSave);
        store.dispatch(setSnackbarMessage('Search Preset is saved successfully.', 'success'));
        setOpenConfirmExit(false);
        setEnable(false);
      }
    }
    setPresetName('');
  };

  const cancelEditPresetFilter = () => {
    if (isEditStarted) {
      setOpenConfirmExit(true);
    } else {
      setPresetSearchData({ isPreset: false, isEdit: false });
      setAnchorElFilter(null);
      setOpen(false);
      handleClear();
      setClear(true);
      setOpenConfirmExit(false);
    }
  };

  const handleEditPresetFilter = async (from: number, size: number) => {
    setMetaData({});
    setPresetSearchData({ isPreset: false, isEdit: false });
    setAnchorElFilter(null);
    setOpen(false);
    handleClear();
    setSave(false);
    setShowResult(false);
    const res_qf = buildPayload();
    if (presetId) {
      const editObj = {
        preset_name: presetName ? presetName : presetSearchData.preset_name,
        id: presetId,
        preset_conditions: {
          filter: res_qf,
          sort: [
            {
              sort_by: 'string',
              sort_order: 'desc'
            }
          ],
          page: {
            start_from: 0,
            size: 10
          }
        },
        updated_by: userName
      };
      const res: any = await docService.updatePresetFilter(
        editObj,
        selectedStudy,
        selectedCountry,
        selectedSite,
        isfLevel,
        process.env.REACT_APP_NAME,
        'Search'
      );
      if (res.error) {
        store.dispatch(setSnackbarMessage('Name already exists.', 'error'));
        setSearchResultRows([]);
      } else {
        setSave(true);
        setAnchorElFilter(null);
        setOpen(false);
        const dataObj = {
          query_filters: res_qf,
          filter_types: findScope()
        };
        const response: any = await docService.getGlobalSearch(
          dataObj,
          null,
          null,
          null,
          isfLevel,
          process.env.REACT_APP_NAME,
          'Search',
          from,
          size
        );
        if (response.data) {
          const modRows: any = getMapFields(response?.data?.selected_data);
          setShowResult(true);
          setSearchResultRows(modRows);
          setRowCount(response.data.record_count);
        } else {
          setSearchResultRows([]);
          setShowResult(true);
        }
        store.dispatch(setSnackbarMessage('Filter preset is modified successfully.', 'success'));
      }
    }
  };

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 300, // phone
        sm: 600, // tablets
        md: 900, // small laptop
        lg: 1200, // desktop
        xl: 1600 // large screens
      }
    }
  });

  const getMapFields = (data: any) => {
    const responseData = data.map((item: any, key: any) => {
      return {
        id: item.document_data.id,
        documentName: item.document_data.isf_document_name,
        filingLevel: item.document_data.isf_doc_level,
        lastModified: formatToDate(item.document_data.updated_on),
        uploadedBy: item.document_data.isf_doc_viewer_created_by,
        status: item.document_data.isf_doc_status,
        created_on: item.document_data.created_on,
        deleted_by: item.document_data.deleted_by,
        deleted_on: item.document_data.deleted_on,
        docFormat: item.file_master.isf_doc_type,
        fileId: item.file_master.id,
        fmId: item.file_master.id,
        is_active: item.file_master.is_active,
        isf_artifact_name: item.document_data.isf_artifact_name,
        isf_artifact_number: item.document_data.isf_artifact_number,
        isf_bucket_name: item.file_master.isf_bucket_name,
        isf_doc_approval_date: item.document_data.isf_doc_approval_date,
        isf_doc_approval_st_dt: item.document_data.isf_doc_approval_st_dt,
        isf_doc_country: item.document_data.isf_doc_country,
        isf_doc_created_by: item.document_data.isf_doc_viewer_created_by,
        isf_doc_date: item.document_data.isf_doc_date,
        isf_doc_viewer_last_modified_by: item.document_data.isf_doc_viewer_last_modified_by,
        isf_doc_level: item.document_data.isf_doc_level,
        isf_doc_milestone: item.document_data.isf_doc_milestone,
        isf_doc_site: item.document_data.isf_doc_site,
        isf_doc_size: item.file_master.isf_doc_size,
        isf_doc_status: item.document_data.isf_doc_status,
        isf_doc_study: item.document_data.isf_doc_study,
        isf_doc_subtype: item.document_data.isf_doc_subtype,
        isf_doc_type: item.document_data.isf_doc_type,
        isf_doc_upload_date: item.file_master.isf_doc_upload_date,
        isf_doc_version_number: item.document_data.isf_doc_version_number,
        isf_doc_viewer_approval_cycle: item.document_data.isf_doc_viewer_approval_cycle,
        isf_doc_viewer_format: item.document_data.isf_doc_viewer_format,
        isf_doc_viewer_inspection_ready: item.document_data.isf_doc_viewer_inspection_ready,
        isf_doc_viewer_ir_issue_type: item.document_data.isf_doc_viewer_ir_issue_type,
        isf_doc_viewer_language: item.document_data.isf_doc_viewer_language,
        isf_doc_viewer_pages: item.file_master.isf_doc_viewer_pages,
        isf_doc_viewer_product_detail: item.document_data.isf_doc_viewer_product_detail,
        isf_doc_viewer_ref_model_version: item.document_data.isf_doc_viewer_ref_model_version,
        isf_doc_viewer_includes_phi: item.document_data.isf_doc_viewer_includes_phi,
        isf_doc_viewer_doc_phi_redacted: item.document_data.isf_doc_viewer_doc_phi_redacted,
        isf_doc_viewer_red_certified_copy: item.document_data.isf_doc_viewer_red_certified_copy,
        isf_document_id: item.document_data.isf_document_id,
        isf_document_name: item.document_data.isf_document_name,
        isf_hashed_file_name: item.file_master.isf_hashed_file_name,
        isf_prefix: item.file_master.isf_prefix,
        isf_raw_file_name: item.file_master.isf_raw_file_name,
        updated_on: item.document_data.updated_on,
        hashed_uri_key: item.hashed_uri_key,
        sent_to_tmf: item.document_data.sent_to_tmf,
        need_sent_to_tmf: item.need_sent_to_tmf
      };
    });
    return responseData;
  };

  const [dataGridComponent, setDataGridComponent] = useState<boolean>(true);
  const [documentToDisplaySearch, setDocumentToDisplaySearch] = useState<any>();
  const [isAdvanceSearch, setIsAdvanceSearch] = useState<boolean>(false);
  const [isPresetSearch, setIsPresetSearch] = useState<boolean>(false);

  const gridFunc = async (searchResultRows: any) => {
    try {
      const response: any = await docService.getDocAccessPermissions(searchResultRows);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        window.scrollTo(0, 0);
        setDocumentToDisplaySearch(searchResultRows);
        setDocumentDetail(dispatch, [searchResultRows]);
        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };

  useEffect(() => {
    if (dataGridComponent || props.onClicked) {
      props.routeInfo && props.routeInfo('');
      setDataGridComponent(true);
      if (isAdvanceSearch === true) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          advancedFilterSearch(0, pageSize);
        } else advancedFilterSearch(page * pageSize, pageSize);
      } else if (isPresetSearch === true) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          presetFilterSearch(0, pageSize);
        } else presetFilterSearch(page * pageSize, pageSize);
      } else {
        if (page * pageSize > rowCount - 1) {
          setPage(0);
          globalSearch(objData, isAction, 0, pageSize);
        } else globalSearch(objData, isAction, page * pageSize, pageSize);
      }
    } else {
      props.routeInfo && props.routeInfo('search');
    }
  }, [page, pageSize, dataGridComponent, props.onClicked]);

  // for Send to ISF Dialog
  const [openSend, setOpenSend] = React.useState(false);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [noOfRows, setNoOfRows] = useState<any>([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [allNewFiles, setAllNewFiles] = useState([]);
  const [isfToBePublishedFiles, setIsfToBePublishedFiles] = useState([]);
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [overwrite, setOverwrite] = useState<boolean>(false);
  const [isEnable, setIsEnable] = useState<boolean>(true);

  const onSelectionModelChange = (ids: any) => {
    setSelectionModel(ids);
    const selectedIds = new Set(ids);
    const filesSelected = searchResultRows
      .filter((row: any) => selectedIds.has(row.id))
      .filter(
        (elem: any) =>
          elem.isf_doc_status === 'Approved' &&
          elem.need_sent_to_tmf === 'Yes' &&
          elem.isf_doc_viewer_ref_model_version.slice(0, 3) === 'ISF' &&
          (elem.isf_doc_viewer_includes_phi === false ||
            (elem.isf_doc_viewer_includes_phi === true && elem.isf_doc_viewer_doc_phi_redacted === 'Y')) &&
          elem.isf_doc_version_number % 1 === 0
      );
    setSelectedFiles(filesSelected);
    const rowSelected = searchResultRows.filter((row: any) => selectedIds.has(row.id)).map((elem: any) => elem.fileId);
    setNoOfRows(rowSelected);
    setSelectedRows(rowSelected);
  };

  const handleClosePopup = () => {
    setChecked(false);
    setOpenSend(false);
  };
  const filterFiles = async () => {
    dispatch(showLoader());
    if (selectedFiles.length > 0) {
      const tempNewFiles: any = [];
      selectedFiles.forEach((file: any) => {
        if (file.sent_to_tmf === false) {
          tempNewFiles.push(file);
        }
      });
      const newVersionFiles: any = [];
      const overwriteOrNewVersionFiles: any = [];
      if (tempNewFiles.length > 0) {
        const payload = { isf_document_ids: tempNewFiles.map((file: any) => file.isf_document_id) };
        const resp: any = await docService.VersionBasedDocuments(payload);
        if (resp.data && resp.data.length > 0) {
          tempNewFiles.forEach((file: any) => {
            if (resp.data.find((resFile: any) => resFile.isf_document_id === file.isf_document_id)) {
              overwriteOrNewVersionFiles.push(file);
            } else {
              newVersionFiles.push(file);
            }
          });
          setAllNewFiles(newVersionFiles);
        } else {
          setAllNewFiles(tempNewFiles);
        }
        setIsfToBePublishedFiles(overwriteOrNewVersionFiles);
      }
      if (overwriteOrNewVersionFiles.length === 0 && (newVersionFiles.length > 0 || tempNewFiles.length > 0)) {
        const fileIds = (newVersionFiles.length > 0 ? newVersionFiles : tempNewFiles)
          .filter((item: any) => item)
          .map((item: any) => item.id);
        const data = { doucment_id: [...fileIds] };
        const response = await docService.BulkUpload(false, 'Search', data);
        if (response.data) {
          if (response.data.doucment_id?.length > 0) {
            store.dispatch(setSnackbarMessage('Document(s) sent to TMF successfully.', 'success'));
            globalSearch(objData, isAction, 0, pageSize);
            onSelectionModelChange([]);
          } else {
            store.dispatch(
              setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error')
            );
          }
        } else {
          store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
        }
      } else if (newVersionFiles.length === 0 && tempNewFiles.length === 0) {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
      } else {
        setOpenSend(true);
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
    }
    dispatch(hideLoader());
  };

  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    if (value === 'newVersion') {
      setOverwrite(false);
    } else {
      setOverwrite(true);
    }
  };

  const handleClickOpenSend = () => {
    if (noOfRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to be sent to TMF at once', 'error'));
    } else {
      filterFiles();
    }
  };

  const handleCloseSend = async () => {
    dispatch(showLoader());
    let response1: any = [];
    let response2: any = [];
    if (isfToBePublishedFiles.length > 0) {
      if (overwrite) {
        response1 = await docService.BulkUpload(true, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      } else {
        response1 = await docService.BulkUpload(false, 'Search', {
          doucment_id: isfToBePublishedFiles.map((file: any) => file.id)
        });
      }
    }
    if (allNewFiles.length > 0) {
      response2 = await docService.BulkUpload(false, 'Search', {
        doucment_id: allNewFiles.map((file: any) => file.id)
      });
    }
    if (response1?.data || response2?.data) {
      if (response1?.data.doucment_id?.length > 0 || response2?.data.doucment_id?.length > 0) {
        store.dispatch(setSnackbarMessage('Document(s) sent to TMF successfully.', 'success'));
        globalSearch(objData, isAction, 0, pageSize);
        onSelectionModelChange([]);
      } else {
        store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
      }
    } else {
      store.dispatch(setSnackbarMessage('None of the selected documents are eligible to be sent to TMF', 'error'));
    }
    setOpenSend(false);
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setIsEnable(false);
    } else {
      setIsEnable(true);
    }
  }, [selectedRows]);

  const url = `${config.appConfig.apiisf}/fileMaster/downloadFiles?isf_doc_level=Site&application=ISF&module_section_related=Search&log=Y&original=N&bulk_download=true`;
  const payload: any = {
    id: selectedRows
  };
  const handleBulkDownload = (url: any) => {
    const newState = store.getState();
    const axiosOptions: any = {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
        sponsor: newState.user.user?.sponsor_sponsor_name,
        sponsor_token: newState.user.user?.sponsorToken,
        Authorization: `Bearer ${newState.user.user?.token}`
      }
    };
    if (selectedRows.length > 10) {
      return store.dispatch(setSnackbarMessage('Maximum 10 documents are allowed to download at once', 'error'));
    } else {
      setLoading(true);
      isfInstance
        .post(url, payload, axiosOptions)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream'
          });
          const filename = 'ISF_Search_Bulk_Download.zip';
          saveAs(blob, filename);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (isEditStarted === true) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        handleEditPresetFilter(0, pageSize);
      } else handleEditPresetFilter(page * pageSize, pageSize);
    }
    if (fromHistory === true) {
      if (page * pageSize > rowCount - 1) {
        setPage(0);
        globalSearchFromHistory(0, 0, pageSize);
      } else globalSearchFromHistory(0, page * pageSize, pageSize);
    }
  }, [page, pageSize]);

  useEffect(() => {
    setLoaderStatus(isLoaderLoading);
  }, [isLoaderLoading]);

  if (loading)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress />
        </Backdrop>
      </>
    );

  // for Custom buttons at Data Grid
  function CustomFooterButtons() {
    return (
      <GridFooterContainer>
        <Box sx={{ p: 1, display: 'flex', columnGap: 1 }}>
          {checkPermission('bulk_download') && (
            <Button variant="outlined" onClick={() => handleBulkDownload(url)} disabled={isEnable}>
              Download
            </Button>
          )}
          <Tooltip
            placement="top"
            title="Only documents configured to be sent to TMF in 'Planning' and those in 'Approved' status will be sent to TMF"
          >
            <Button
              variant="outlined"
              onClick={handleClickOpenSend}
              className={checkPermission('send_to_tmf') ? '' : 'hide'}
              disabled={noOfRows.length <= 0}
            >
              Send to TMF
            </Button>
          </Tooltip>
        </Box>

        <GridFooter />
      </GridFooterContainer>
    );
  }
  return (
    <React.Fragment>
      {dataGridComponent ? (
        <div>
          <>
            <Box>
              <Grid container className="search-block" spacing={2}>
                <Grid item md={9}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div>
                      <Button
                        id="all-button"
                        aria-controls={open ? 'all-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        variant="contained"
                        disableElevation
                        onClick={handleClick}
                        endIcon={<ArrowDropDownIcon />}
                        className="searchAll-btn"
                      >
                        <span>{scopeText}</span>
                      </Button>

                      <StyledMenu
                        id="all-menu"
                        MenuListProps={{
                          'aria-labelledby': 'all-button'
                        }}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        PaperProps={{
                          style: {
                            maxHeight: ITEM_HEIGHT * 5,
                            width: '175'
                          }
                        }}
                        className="allDropDownMenu"
                      >
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="All" checked={AllCbx} onChange={handleChangeAllCbx} />}
                            label="All"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="Name" checked={NameCbx} onChange={handleChangeNameCbx} />}
                            label="Name"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={<Checkbox value="Detail" checked={DetailCbx} onChange={handleChangeDetailCbx} />}
                            label="Details"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={
                              <Checkbox
                                value="Properties"
                                checked={PropertiesCbx}
                                onChange={handleChangePropertiesCbx}
                              />
                            }
                            label="Properties"
                          />
                        </MenuItem>
                        <MenuItem>
                          <FormControlLabel
                            control={
                              <Checkbox value="Content" checked={ContentCbx} onChange={handleChangeContentCbx} />
                            }
                            label="Content"
                          />
                        </MenuItem>
                      </StyledMenu>
                    </div>
                    <FormControl variant="standard">
                      <Input
                        id="input-with-icon-adornment"
                        onChange={handleSearchInputChange}
                        onKeyDown={handleKeyDown}
                        onClick={handleClickInsideInput}
                        autoComplete="off"
                        value={inputValue}
                        className="search-main-input"
                        placeholder="Search by document name, status, version, type, etc"
                        startAdornment={
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-controls={open ? 'long-menu' : undefined}
                              aria-expanded={open ? 'true' : undefined}
                              aria-haspopup="true"
                              onClick={handleClickSearch}
                            >
                              <SearchIcon />
                            </IconButton>
                            {(showSuggestion || showHistory) &&
                              (suggestionResult?.length > 0 || recentHistoryResult?.length > 0) && (
                                <Popover
                                  id={id}
                                  open={open2}
                                  anchorEl={anchorElSearch}
                                  onClose={handleCloseSearch}
                                  anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left'
                                  }}
                                  className={'SearchItemsPop' + (showHistory === true ? ' withHistory' : ' noHistory')}
                                  disableAutoFocus={true}
                                >
                                  <MenuList>
                                    {showSuggestion &&
                                      suggestionResult?.map((item: any, i: any) => {
                                        return (
                                          <MenuItem
                                            disableRipple
                                            key={i}
                                            onClick={() => globalSearch(i, 'click', 0, pageSize)}
                                          >
                                            {`${item.actual_value}`} -&nbsp;&nbsp;{' '}
                                            <span className="column_name"> {item.filter_column} </span>
                                          </MenuItem>
                                        );
                                      })}

                                    {showHistory &&
                                      recentHistoryResult?.slice(0, 5).map((item: any, i: any) => {
                                        return (
                                          <MenuItem
                                            disableRipple
                                            key={i}
                                            onClick={() => globalSearchFromHistory(i, 0, pageSize)}
                                          >
                                            <HistoryIcon sx={{ mr: 1 }} /> {`${item.actual_value}`} -&nbsp;&nbsp;{' '}
                                            <span className="column_name"> {item.filter_column} </span>
                                          </MenuItem>
                                        );
                                      })}
                                  </MenuList>
                                </Popover>
                              )}
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                    <div className="search-filter-iconbtn-wrap focused">
                      <IconButton
                        aria-label="Advance Search Filter"
                        id="filter-button"
                        aria-controls={open ? 'filter' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleClickFilter('bottom-end')}
                        tabIndex={2}
                        title="Show Advance Search Filters"
                      >
                        <Badge badgeContent={badgeCount} color="primary" className="small-badge">
                          <TuneIcon />
                        </Badge>
                      </IconButton>
                      <Popper
                        id="filter"
                        open={open3 || isEdit ? true : false}
                        anchorEl={anchorElFilter}
                        placement={placement}
                        transition
                        className="SearchFiltersPop"
                        onResize={undefined}
                        onResizeCapture={undefined}
                      >
                        {({ TransitionProps }) => (
                          <ClickAwayListener onClickAway={handleClickAway}>
                            <Fade {...TransitionProps} timeout={350}>
                              <Paper elevation={5}>
                                <Paper
                                  elevation={0}
                                  sx={{
                                    p: 1,
                                    pl: 3,
                                    pr: 3
                                  }}
                                >
                                  <Grid sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Grid>
                                      {isPreset && isPreset ? (
                                        <Typography variant="h6" component="div">
                                          <TextField
                                            id="standard-basic"
                                            label="Name of Preset"
                                            onChange={e => {
                                              setPresetName(e.target.value.trim());
                                              if (!e.target.value.trim()) {
                                                setIsPresetName(true);
                                                setIsEditStarted(false);
                                              } else {
                                                setIsEditStarted(true);
                                                setIsPresetName(false);
                                              }
                                            }}
                                            variant="standard"
                                            defaultValue={presetSearchData.preset_name}
                                            inputProps={{
                                              maxLength: 16
                                            }}
                                          ></TextField>
                                        </Typography>
                                      ) : (
                                        <Typography variant="h6" component="div">
                                          Filters
                                        </Typography>
                                      )}
                                    </Grid>
                                    <Grid>
                                      <Button size="small" sx={{ mr: -1 }} onClick={handleClear}>
                                        Clear
                                      </Button>
                                    </Grid>
                                  </Grid>
                                  <Box
                                    sx={{
                                      maxHeight: '53vh',
                                      overflowY: 'auto',
                                      overflowX: 'hidden',
                                      mr: '-8px',
                                      pr: '8px'
                                    }}
                                    className="scrollBox"
                                  >
                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p1Expand}
                                      onChange={() => setP1Expand(!p1Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                      >
                                        <Typography>Document Details</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={3} rowSpacing={1.5}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="Type"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setTypeVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={type}
                                                value={isPreset ? metaData.isf_doc_type : typeVal}
                                                inputValue={inputTypeVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, isf_doc_type: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, isf_doc_type: newInputValue });
                                                    setInputTypeVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Type"
                                                    name="isf_doc_type"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="Subtype"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setSubTypeVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={subType}
                                                value={isPreset ? metaData.isf_doc_subtype : subTypeVal}
                                                inputValue={inputSubTypeVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, isf_doc_subtype: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, isf_doc_subtype: newInputValue });
                                                    setInputSubTypeVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Subtype"
                                                    name="isf_doc_subtype"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <Autocomplete
                                                disablePortal
                                                id="ArtifactName"
                                                onChange={(event: any, newValue: string | null) => {
                                                  setArtifactNameVal(newValue);
                                                  setIsEditStarted(true);
                                                }}
                                                options={artifactName}
                                                value={isPreset ? metaData.isf_artifact_name : artifactNameVal}
                                                inputValue={inputArtifactNameVal}
                                                onInputChange={(event, newInputValue, reason) => {
                                                  if (reason === 'clear') {
                                                    setMetaData({ ...metaData, isf_artifact_name: '' });
                                                  } else {
                                                    setMetaData({ ...metaData, isf_artifact_name: newInputValue });
                                                    setInputArtifactNameVal(newInputValue);
                                                  }
                                                }}
                                                renderInput={params => (
                                                  <TextField
                                                    {...params}
                                                    label="Artifact Name"
                                                    name="isf_artifact_name"
                                                    variant="standard"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                              />
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Document Status"
                                                name="isf_doc_status"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.isf_doc_status : docStatusVal}
                                                value={isPreset ? metaData.isf_doc_status : docStatusVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {docStatuses?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-basic"
                                                label="Document Name"
                                                name="isf_document_name"
                                                defaultValue={isPreset ? metaData.isf_document_name : docNameVal}
                                                inputRef={docNameInput}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                              ></TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-basic"
                                                label="Document Number"
                                                name="isf_document_id"
                                                defaultValue={isPreset ? metaData.isf_document_id : docIdVal}
                                                inputRef={docNoInput}
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                              ></TextField>
                                            </FormControl>
                                          </Grid>

                                          {/* <Grid item md={4}>
                                        <FormControl fullWidth>
                                          <TextField
                                            id="standard-select-filtervalue"
                                            select
                                            label="Filing Level"
                                            name="isf_doc_level"
                                            onChange={handleAdvFieldChange}
                                            variant="standard"
                                            InputLabelProps={{ shrink: true }}
                                            defaultValue={isPreset ? metaData.isf_doc_level : docLevelVal}
                                            value={docLevelVal}
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                          >
                                            <MenuItem value=""></MenuItem>
                                            {isflevels?.map((item: any, i: number) => (
                                              <MenuItem value={item} key={i}>
                                                {item}
                                              </MenuItem>
                                            ))}
                                          </TextField>
                                        </FormControl>
                                      </Grid> */}
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Study"
                                                name="isf_doc_study"
                                                onChange={e => {
                                                  setDocStudyVal(e.target.value);
                                                  setCurrentStudy(e.target.value);
                                                  isPreset && setIsEditStarted(true);
                                                }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.isf_doc_study : docStudyVal}
                                                value={docStudyVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {studyList.map((item: string, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Country"
                                                name="isf_doc_country"
                                                onChange={e => {
                                                  setCountryVal(e.target.value);
                                                  setCurrentCountry(e.target.value);
                                                  isPreset && setIsEditStarted(true);
                                                }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.isf_doc_country : countryVal}
                                                value={countryVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {countryList.map((item: string, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Site"
                                                name="isf_doc_site"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.isf_doc_site : siteVal}
                                                value={siteVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {siteList?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>

                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p2Expand}
                                      onChange={() => setP2Expand(!p2Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel2a-header"
                                      >
                                        <Typography>Milestone Status</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={3}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Milestone"
                                                name="isf_doc_milestone"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={isPreset ? metaData.isf_doc_milestone : milestoneVal}
                                                value={milestoneVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                                {milestones?.map((item: any, i: number) => (
                                                  <MenuItem value={item} key={i}>
                                                    {item}
                                                  </MenuItem>
                                                ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Milestone Status"
                                                name="isf_doc_milestone_status"
                                                onChange={handleAdvFieldChange}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.isf_doc_milestone_status : mileStatusVal
                                                }
                                                value={isPreset ? metaData.isf_doc_milestone_status : mileStatusVal}
                                              >
                                                <MenuItem value=""></MenuItem>
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>

                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Product"
                                                name="isf_doc_viewer_product_detail"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.isf_doc_viewer_product_detail : productVal
                                                }
                                                value={productVal}
                                                SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                              >
                                                <MenuItem value=""></MenuItem>
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>

                                    <Accordion
                                      className="searchFilterAccordion"
                                      expanded={p3Expand}
                                      onChange={() => setP3Expand(!p3Expand)}
                                    >
                                      <AccordionSummary
                                        expandIcon={<AddIcon />}
                                        aria-controls="panel3a-content"
                                        id="panel3a-header"
                                      >
                                        <Typography>Modification Details</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        <Grid container direction="row" spacing={4}>
                                          <Grid item md={6}>
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{ mb: 2, display: 'flex' }}
                                              className="custom-datePickerWrapper"
                                            >
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label="Uploaded From"
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(uploadedFromDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidUploadedFromDate(err, value)
                                                    }
                                                    onChange={(newValue: any) => {
                                                      setuploadedFromDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                    className="smalllabel"
                                                    minDate={new Date('2017-01-01')}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                              <Grid
                                                item
                                                md={2}
                                                sx={{
                                                  display: 'flex',
                                                  alignSelf: 'end',
                                                  lineHeight: 2,
                                                  justifyContent: 'center'
                                                }}
                                              >
                                                to
                                              </Grid>
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label=" "
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(uploadedToDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidUploadedToDate(err, value)
                                                    }
                                                    minDate={uploadedFromDate}
                                                    onChange={(newValue: any) => {
                                                      setuploadedToDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                          <Grid item md={6}>
                                            <Grid
                                              container
                                              spacing={1}
                                              sx={{ mb: 2, display: 'flex' }}
                                              className="custom-datePickerWrapper"
                                            >
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label="Last Modified"
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(modifiedFromDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidModifiedFromDate(err, value)
                                                    }
                                                    onChange={(newValue: any) => {
                                                      setmodifiedFromDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                    className="smalllabel"
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                              <Grid
                                                item
                                                md={2}
                                                sx={{
                                                  display: 'flex',
                                                  alignSelf: 'end',
                                                  lineHeight: 2,
                                                  justifyContent: 'center'
                                                }}
                                              >
                                                to
                                              </Grid>
                                              <Grid item md={5}>
                                                <LocalizationProvider
                                                  dateAdapter={AdapterDateFns}
                                                  variant="standard"
                                                  className="custom-datePicker"
                                                >
                                                  <DesktopDatePicker
                                                    disableFuture
                                                    label=" "
                                                    inputFormat={userPreferedDateFormat}
                                                    value={preferedFormatForDatePicker(modifiedToDate)}
                                                    onError={(err: any, value: any) =>
                                                      handleInvalidModifiedToDate(err, value)
                                                    }
                                                    minDate={modifiedFromDate}
                                                    onChange={(newValue: any) => {
                                                      setmodifiedToDate(newValue);
                                                      setIsEditStarted(true);
                                                    }}
                                                    renderInput={(params: any) => (
                                                      <TextField
                                                        {...params}
                                                        variant="standard"
                                                        InputLabelProps={{ shrink: true }}
                                                      />
                                                    )}
                                                  />
                                                </LocalizationProvider>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                        <Grid container direction="row" spacing={3}>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Uploaded By"
                                                name="isf_doc_viewer_created_by"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.isf_doc_viewer_created_by : createdbyVal
                                                }
                                                value={isPreset ? metaData.isf_doc_viewer_created_by : createdbyVal}
                                                SelectProps={{
                                                  MenuProps: {
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                      style: {
                                                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                                        width: 250
                                                      }
                                                    }
                                                  }
                                                }}
                                              >
                                                {usersList?.length > 0 &&
                                                  usersList.map((user: any, index: number) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={user.firstName + ' ' + user.lastName}
                                                      sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                                                    >
                                                      {`${user.firstName}  ${user.lastName} (${user.email})`}
                                                    </MenuItem>
                                                  ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}>
                                            <FormControl fullWidth>
                                              <TextField
                                                id="standard-select-filtervalue"
                                                select
                                                label="Modified By"
                                                name="isf_doc_viewer_last_modified_by"
                                                onChange={handleAdvFieldChange}
                                                variant="standard"
                                                InputLabelProps={{ shrink: true }}
                                                defaultValue={
                                                  isPreset ? metaData.isf_doc_viewer_last_modified_by : modifiedbyVal
                                                }
                                                value={
                                                  isPreset ? metaData.isf_doc_viewer_last_modified_by : modifiedbyVal
                                                }
                                                SelectProps={{
                                                  MenuProps: {
                                                    disableScrollLock: true,
                                                    PaperProps: {
                                                      style: {
                                                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                                                        width: 250
                                                      }
                                                    }
                                                  }
                                                }}
                                              >
                                                {usersList?.length > 0 &&
                                                  usersList.map((user: any, index: number) => (
                                                    <MenuItem
                                                      key={index}
                                                      value={user.firstName + ' ' + user.lastName}
                                                      sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                                                    >
                                                      {`${user.firstName}  ${user.lastName} (${user.email})`}
                                                    </MenuItem>
                                                  ))}
                                              </TextField>
                                            </FormControl>
                                          </Grid>
                                          <Grid item md={4}></Grid>
                                          {/* <Grid item md={4}>
                                        <FormControl fullWidth>
                                          <TextField
                                            id="standard-select-filtervalue"
                                            select
                                            label="QC Issue Type"
                                            name="isf_doc_viewer_qc_issue_type"
                                            onChange={handleAdvFieldChange}
                                            variant="standard"
                                            InputLabelProps={{ shrink: true }}
                                            defaultValue={isPreset ? metaData.isf_doc_viewer_qc_issue_type : qcissueVal}
                                            value={isPreset ? metaData.isf_doc_viewer_qc_issue_type : qcissueVal}
                                            SelectProps={{ MenuProps: { disableScrollLock: true } }}
                                          >
                                            <MenuItem value=""></MenuItem>
                                            {qcIssueTypes?.map((item: any, i: number) => (
                                              <MenuItem value={item} key={i}>
                                                {item}
                                              </MenuItem>
                                            ))}
                                          </TextField>
                                        </FormControl>
                                      </Grid> */}
                                          {/* <Grid item md={4}>
                                        <FormControl fullWidth>
                                          <TextField
                                            id="standard-basic"
                                            label="QC Issue Comments"
                                            name="isf_doc_viewer_qc_issue_comments"
                                            defaultValue={
                                              isPreset ? metaData.isf_doc_viewer_qc_issue_comments : qccommentVal
                                            }
                                            inputRef={qcCommentsInput}
                                            onChange={handleAdvFieldChange}
                                            variant="standard"
                                            InputLabelProps={{ shrink: true }}
                                          ></TextField>
                                        </FormControl>
                                      </Grid> */}
                                          <Grid item md={4}></Grid>
                                        </Grid>
                                      </AccordionDetails>
                                    </Accordion>
                                  </Box>
                                  <FormGroup sx={{ mt: 1, flexDirection: 'row', columnGap: '16px' }}>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={includePhi}
                                          onClick={cbxPHIClick}
                                          name="isf_doc_viewer_includes_phi"
                                        />
                                      }
                                      label="Includes PHI?"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={docReducted}
                                          onClick={cbxReductedClick}
                                          name="isf_doc_viewer_red_certified_copy"
                                        />
                                      }
                                      label="Document Redacted"
                                    />
                                  </FormGroup>

                                  <Stack
                                    spacing={2}
                                    direction="row"
                                    sx={{ display: 'flex', justifyContent: 'flex-end', my: 1 }}
                                  >
                                    {isPreset && isPreset ? (
                                      <div>
                                        <Button onClick={() => cancelEditPresetFilter()}>Cancel</Button>
                                        <Button
                                          onClick={() => handleEditPresetFilter(0, pageSize)}
                                          disabled={!isEditStarted || isPresetName}
                                        >
                                          Save and Search
                                        </Button>
                                      </div>
                                    ) : (
                                      <>
                                        <Button onClick={handleSaveDialogBox}>Save Preset</Button>
                                        <Button onClick={() => advancedFilterSearch(0, pageSize)}>Search</Button>
                                        <PopupComponent
                                          open={enable}
                                          aria-labelledby="alert-dialog-title"
                                          aria-describedby="alert-dialog-description"
                                          className="savePresetDialog"
                                        >
                                          <DialogTitle id="alert-dialog-title">{'Save Preset'}</DialogTitle>
                                          <DialogContent>
                                            <DialogContentText id="alert-dialog-description"></DialogContentText>
                                            <Grid item md={12}>
                                              <FormControl fullWidth>
                                                <TextField
                                                  id="standard-basic"
                                                  label="Name of Preset"
                                                  onChange={e => handlePresetName(e)}
                                                  variant="standard"
                                                  inputProps={{
                                                    maxLength: 16
                                                  }}
                                                  // helperText={error} // error message
                                                  error={!!error}
                                                ></TextField>
                                              </FormControl>
                                            </Grid>
                                          </DialogContent>
                                          <DialogActions>
                                            <Button onClick={handleSaveClose} autoFocus>
                                              CANCEL
                                            </Button>
                                            <Button onClick={() => handleSavePresetFilter(true)} disabled={!presetName}>
                                              SAVE
                                            </Button>
                                          </DialogActions>
                                        </PopupComponent>
                                      </>
                                    )}
                                  </Stack>
                                </Paper>
                              </Paper>
                            </Fade>
                          </ClickAwayListener>
                        )}
                      </Popper>
                    </div>
                  </Box>
                </Grid>
                <PopupComponent
                  open={openDeletePreset}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{`Delete Preset`}</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      {`Are you really want to delete the filter preset ?`}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDeletePreset}>No</Button>
                    <Button onClick={() => handleDeletePreset(true)} autoFocus>
                      Yes
                    </Button>
                  </DialogActions>
                </PopupComponent>
                <Grid item md={3} sx={{ display: 'flex', alignItems: 'flex-end' }}>
                  <SearchPreset
                    isSave={isSave}
                    setPresetSearchData={setPresetSearchData}
                    presetName={presetName}
                    isClear={isClear}
                    handleClear={handleClear}
                    isPresetValue={isPreset}
                    metaData={metaData}
                    setShowResult={setShowResult}
                  />
                </Grid>
              </Grid>
              {showResult && (
                <Box className="resultBox">
                  <Typography variant="h6" component="div">
                    Results
                  </Typography>

                  <div style={{ height: '65vh', width: '100%' }}>
                    <DataGridPro
                      rows={searchResultRows}
                      columns={columns}
                      disableSelectionOnClick
                      rowCount={rowCount}
                      page={page}
                      onPageChange={newPage => setPage(newPage)}
                      paginationMode="server"
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize: any) => setPageSize(newPageSize)}
                      rowsPerPageOptions={[5, 10, 20]}
                      checkboxSelectionVisibleOnly={true}
                      pagination
                      components={{
                        NoRowsOverlay: CustomNoRowsOverlay,
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterButtons,
                        Pagination: CustomPagination
                      }}
                      columnVisibilityModel={columnVisibilityModel}
                      onColumnVisibilityModelChange={(newModel: any) => {
                        setColumnVisibilityModel(newModel);
                      }}
                      className="SearchResult_DataGrid"
                      checkboxSelection
                      selectionModel={selectionModel}
                      onSelectionModelChange={onSelectionModelChange}
                    />
                  </div>
                </Box>
              )}
            </Box>
          </>
        </div>
      ) : (
        <div>
          <DocumentViewerComponent
            documentDetails={documentToDisplaySearch}
            props={props}
            setDataGridComponent={setDataGridComponent}
          />
        </div>
      )}

      {/* -- for Send to TMF Dialog -- */}
      <PopupComponent open={openSend}>
        <Loader open={loaderStatus} />
        <DialogTitle>Send to TMF</DialogTitle>
        <DialogContent className="sendToDialog">
          <DialogContentText>The following documents already exist in TMF:</DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              {isfToBePublishedFiles.map((item: any) => {
                return (
                  <ListItem disablePadding key={item.id}>
                    <ListItemButton>
                      <ListItemText primary={item.isf_document_name} />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          </Paper>

          <FormControl>
            <RadioGroup
              aria-labelledby="sent to TMF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleCloseSend} disabled={!checked}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child={true}
      >
        <DialogTitle id="alert-dialog-title">
          <b>Confirm Exit</b>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Changes you made will not be saved. Are you sure you want to exit before saving your changes?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
              setClickListner(false);
            }}
            className="grey-btn"
          >
            CLOSE
          </Button>
          {presetName ? (
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
                setClickListner(true);
                setEnable(false);
              }}
            >
              EXIT
            </Button>
          ) : (
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
                setClickListner(true);
                setPresetSearchData({ isPreset: false, isEdit: false });
                setAnchorElFilter(null);
                setOpen(false);
                handleClear();
                setClear(true);
              }}
            >
              EXIT
            </Button>
          )}
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(SearchComponent);
